import { forwardRef } from 'react'

import { Root, Thumb, SwitchProps as RootProps } from '@radix-ui/react-switch'
import cl from 'clsx'

import { SvgIconComponent } from '@/shared/icons'

import classes from './Switch.module.scss'

export type SwitchProps = Omit<
    RootProps,
    'children' | 'checked' | 'onCheckedChange' | 'defaultChecked'
> & {
    uncheckedText?: string
    UncheckedIcon?: SvgIconComponent
    checkedText?: string
    CheckedIcon?: SvgIconComponent
} & Required<Pick<RootProps, 'checked' | 'onCheckedChange'>>

export const Switch = forwardRef<HTMLButtonElement, SwitchProps>(
    function Switch(
        {
            className,
            uncheckedText,
            UncheckedIcon,
            checkedText,
            CheckedIcon,
            checked,
            onCheckedChange,
            ...rest
        },
        ref
    ) {
        return (
            <Root
                {...{
                    ...rest,
                    checked,
                    onCheckedChange,
                    ref,
                }}
                className={cl(classes.root, className)}
            >
                <Thumb className={classes.thumb}>
                    {checked
                        ? CheckedIcon && (
                              <CheckedIcon className={classes.icon} />
                          )
                        : UncheckedIcon && (
                              <UncheckedIcon className={classes.icon} />
                          )}
                </Thumb>
                <div className={cl(classes.text, classes.unchecked)}>
                    {checked ? checkedText : uncheckedText}
                </div>
            </Root>
        )
    }
)
